import React from 'react'
import {connect} from 'react-redux'
import {setPasswordCheckCalcs, setPasswordCheckFailureCalcs} from "../actions/index"
import {passwordCheckService} from "../service/PasswordCheckService"

class PasswordCheckImplComponent extends React.Component {
    constructor(props) {
        super(props);

        this.skipCalcs = props.skipCalcs;
        if (!this.skipCalcs || this.skipCalcs.length === 0) {
            this.skipCalcs = ["none"];
        }
        this.dispatch = props.dispatch;
        this.failClass = props.failClass ? props.failClass : "password-check--fail";
        this.passClass = props.passClass ? props.passClass : "password-check--pass";
        this.failInitial = typeof props.failInitial === 'undefined' ? true : false;
        this.allowBlankPassword = typeof props.allowBlankPassword === 'undefined' ? false : props.allowBlankPassword;
        this.label = props.label ? props.label : "Password rules";
        this.className = props.className;
        this.passwordCheckRef = props.passwordCheckRef;

        this.fetchRules = this.fetchRules.bind(this);
        this.computeClassName = this.computeClassName.bind(this);
        this.getState = this.getState.bind(this);

    }

    componentDidMount() {
        this.fetchRules();
        if (this.passwordCheckRef) {
            this.passwordCheckRef(this.createInstance());
        }
    }

    fetchRules() {
        const dispatch = this.dispatch;
        passwordCheckService.findCalcNames()
            .then((result) => {
                dispatch(setPasswordCheckCalcs(result));
            })
            .catch((error) => {
                console.log("Error occurs while trying to find calc names: " + JSON.stringify(error));
            });
    }

    computeClassName(curCalc, failedCalcs) {
        const calcKey = curCalc.key;
        if (failedCalcs) {
            if (failedCalcs.indexOf(calcKey) >= 0) {
                return this.failClass;
            } else {
                return this.passClass;
            }
        } else {
            if (this.failInitial) {
                return this.failClass;
            } else {
                return "";
            }
        }
    }

    getState() {
        return this.state ? this.state : {};
    }

    createInstance() {
        const dispatch = this.dispatch;
        const {calcListener=()=>{}, calcErrorListener=()=>{}, debounce} = this.props;
        return {
            passwordChangeHandler: (monitoredFieldValues) => {
                const {password=""} = monitoredFieldValues;
                if (password.length === 0 && this.allowBlankPassword){
                    dispatch(setPasswordCheckFailureCalcs(null));
                } else {
                    const {checkTimeoutId} = this.getState();
                    if (typeof (checkTimeoutId) !== "undefined"){
                        clearTimeout(checkTimeoutId);
                    }
                    const checkCall = () => {
                        passwordCheckService.findFailureCalcs(monitoredFieldValues)
                            .then((result) => {
                                calcListener(result);
                                dispatch(setPasswordCheckFailureCalcs(result));
                            })
                            .catch((error) => {
                                calcErrorListener(error);
                                console.log("Error occurs while trying to find calc names: " + error)
                            });
                    };

                    if (debounce && debounce > 0){
                        this.setState({...this.getState(), checkTimeoutId: setTimeout(checkCall, debounce)});
                    } else {
                        checkCall();
                    }


                }

            }
        }

    }

    render() {
        const {calcs=[], failedCalcs} = (this.props.state ? this.props.state : {});

        return (
            <div className={this.className +  " uno-password-check"}>
                <h4 className="flush--bottom">{this.label}:</h4>
                <ul className="list--not-decorated push--left flush--bottom">
                    {
                        calcs.map((calc) => (<li id={calc.key} style={{display:'flex'}} className={this.computeClassName(calc, failedCalcs)}>
                            <span><div dangerouslySetInnerHTML={{__html:calc.value}}></div></span>
                        </li>))
                    }
                </ul>
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => ({
    state: state.passwordCheck ? state.passwordCheck : {},
    ...ownProps
});

const PasswordCheckComponent = connect(mapStateToProps)(PasswordCheckImplComponent);
export default PasswordCheckComponent;